import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "flex flex-col mt-4" }
const _hoisted_2 = {
  key: 0,
  class: "bg-error text-white text-center rounded p-2 mb-2"
}
const _hoisted_3 = {
  key: 1,
  class: "flex flex-row justify-between items-center"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { class: "font-semibold" }, "Payment information", -1)
const _hoisted_5 = {
  key: 2,
  class: "flex flex-row justify-between items-center bg-primary-background rounded-2xl px-4 py-2"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", { class: "font-semibold" }, "You're now editing this candidate profile", -1)
const _hoisted_7 = { class: "flex flex-col mt-4" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", { class: "font-semibold mb-4" }, "Employee information", -1)
const _hoisted_9 = { class: "flex flex-col" }
const _hoisted_10 = { class: "flex flex-row mb-2" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "w-52" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "text-gray-500 capitalize" }, "Employee ID")
], -1)
const _hoisted_12 = { class: "ml-4" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "h-px w-full bg-gray-300 my-2" }, null, -1)
const _hoisted_14 = { class: "flex flex-row mb-2" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { class: "w-52" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "text-gray-500 capitalize" }, "ID Department")
], -1)
const _hoisted_16 = { class: "ml-4 capitalize" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", { class: "h-px w-full bg-gray-300 my-2" }, null, -1)
const _hoisted_18 = { class: "flex flex-row mb-2" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", { class: "w-52" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "text-gray-500 capitalize" }, "ID Job Title")
], -1)
const _hoisted_20 = {
  key: 0,
  class: "ml-4 capitalize"
}
const _hoisted_21 = /*#__PURE__*/_createElementVNode("div", { class: "h-px w-full bg-gray-300 my-2" }, null, -1)
const _hoisted_22 = { class: "flex flex-row mb-2" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("div", { class: "w-52" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "text-gray-500 capitalize" }, "CURP")
], -1)
const _hoisted_24 = {
  key: 0,
  class: "ml-4 capitalize"
}
const _hoisted_25 = /*#__PURE__*/_createElementVNode("div", { class: "h-px w-full bg-gray-300 my-2" }, null, -1)
const _hoisted_26 = { class: "flex flex-row mb-2" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("div", { class: "w-52" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "text-gray-500 capitalize" }, "RFC")
], -1)
const _hoisted_28 = {
  key: 0,
  class: "ml-4 capitalize"
}
const _hoisted_29 = /*#__PURE__*/_createElementVNode("div", { class: "h-px w-full bg-gray-300 my-2" }, null, -1)
const _hoisted_30 = { class: "flex flex-row mb-2" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("div", { class: "w-52" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "text-gray-500 capitalize" }, "Start date")
], -1)
const _hoisted_32 = {
  key: 0,
  class: "ml-4 capitalize"
}
const _hoisted_33 = /*#__PURE__*/_createElementVNode("div", { class: "h-px w-full bg-gray-300 my-2" }, null, -1)
const _hoisted_34 = { class: "flex flex-col mt-4" }
const _hoisted_35 = /*#__PURE__*/_createElementVNode("span", { class: "font-semibold mb-4" }, "Insurance and bank information", -1)
const _hoisted_36 = { class: "flex flex-col" }
const _hoisted_37 = { class: "flex flex-row items-center mb-2" }
const _hoisted_38 = /*#__PURE__*/_createElementVNode("div", { class: "w-52" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "text-gray-500 capitalize" }, "Daily Salary")
], -1)
const _hoisted_39 = { class: "ml-4 capitalize" }
const _hoisted_40 = /*#__PURE__*/_createStaticVNode("<div class=\"h-px w-full bg-gray-300 my-2\"></div><div class=\"flex flex-row items-center mb-2\"><div class=\"w-52\"><span class=\"text-gray-500 capitalize\">IMSS</span></div><span class=\"ml-4 capitalize\"> TBD </span></div><div class=\"h-px w-full bg-gray-300 my-2\"></div>", 3)
const _hoisted_43 = { class: "flex flex-row items-center mb-2" }
const _hoisted_44 = /*#__PURE__*/_createElementVNode("div", { class: "w-52" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "text-gray-500 capitalize" }, "Date Of Entry IMSS")
], -1)
const _hoisted_45 = {
  key: 0,
  class: "ml-4 capitalize"
}
const _hoisted_46 = /*#__PURE__*/_createElementVNode("div", { class: "h-px w-full bg-gray-300 my-2" }, null, -1)
const _hoisted_47 = { class: "flex flex-row items-center mb-2" }
const _hoisted_48 = /*#__PURE__*/_createElementVNode("div", { class: "w-52" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "text-gray-500 capitalize" }, "Bank")
], -1)
const _hoisted_49 = {
  key: 0,
  class: "ml-4 capitalize"
}
const _hoisted_50 = ["value"]
const _hoisted_51 = /*#__PURE__*/_createElementVNode("div", { class: "h-px w-full bg-gray-300 my-2" }, null, -1)
const _hoisted_52 = { class: "flex flex-row items-center mb-2" }
const _hoisted_53 = /*#__PURE__*/_createElementVNode("div", { class: "w-52" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "text-gray-500 capitalize" }, "Bank Branch Office")
], -1)
const _hoisted_54 = {
  key: 0,
  class: "ml-4 capitalize"
}
const _hoisted_55 = /*#__PURE__*/_createElementVNode("div", { class: "h-px w-full bg-gray-300 my-2" }, null, -1)
const _hoisted_56 = { class: "flex flex-row items-center mb-2" }
const _hoisted_57 = /*#__PURE__*/_createElementVNode("div", { class: "w-52" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "text-gray-500 capitalize" }, "Bank Plaza")
], -1)
const _hoisted_58 = {
  key: 0,
  class: "ml-4 capitalize"
}
const _hoisted_59 = /*#__PURE__*/_createElementVNode("div", { class: "h-px w-full bg-gray-300 my-2" }, null, -1)
const _hoisted_60 = { class: "flex flex-row items-center mb-2" }
const _hoisted_61 = /*#__PURE__*/_createElementVNode("div", { class: "w-52" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "text-gray-500 capitalize" }, "Account")
], -1)
const _hoisted_62 = {
  key: 0,
  class: "ml-4 capitalize"
}
const _hoisted_63 = /*#__PURE__*/_createElementVNode("div", { class: "h-px w-full bg-gray-300 my-2" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.error)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, " Something went wrong, please try again. "))
      : _createCommentVNode("", true),
    (!_ctx.editing)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _hoisted_4,
          _createElementVNode("button", {
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.startEditing && _ctx.startEditing(...args))),
            class: "border-2 border-primary rounded-full text-primary px-4 py-2"
          }, " Edit ")
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _hoisted_6,
          _createElementVNode("button", {
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.finishEditing && _ctx.finishEditing(...args))),
            class: "rounded-full bg-primary text-white px-6 py-2"
          }, " Done editing ")
        ])),
    _createElementVNode("div", _hoisted_7, [
      _hoisted_8,
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, [
          _hoisted_11,
          _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.info.id), 1)
        ]),
        _hoisted_13,
        _createElementVNode("div", _hoisted_14, [
          _hoisted_15,
          _createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.info.department_id), 1)
        ]),
        _hoisted_17,
        _createElementVNode("div", _hoisted_18, [
          _hoisted_19,
          (!_ctx.editing)
            ? (_openBlock(), _createElementBlock("span", _hoisted_20, _toDisplayString(_ctx.info.job_title), 1))
            : _withDirectives((_openBlock(), _createElementBlock("input", {
                key: 1,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.info.job_title) = $event)),
                type: "text",
                placeholder: "Value",
                class: "bg-background rounded-2xl p-4 focus:outline-none"
              }, null, 512)), [
                [_vModelText, _ctx.info.job_title]
              ])
        ]),
        _hoisted_21,
        _createElementVNode("div", _hoisted_22, [
          _hoisted_23,
          (!_ctx.editing)
            ? (_openBlock(), _createElementBlock("span", _hoisted_24, _toDisplayString(_ctx.info.curp), 1))
            : _withDirectives((_openBlock(), _createElementBlock("input", {
                key: 1,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.info.curp) = $event)),
                type: "text",
                placeholder: "Value",
                class: "bg-background rounded-2xl p-4 focus:outline-none"
              }, null, 512)), [
                [_vModelText, _ctx.info.curp]
              ])
        ]),
        _hoisted_25,
        _createElementVNode("div", _hoisted_26, [
          _hoisted_27,
          (!_ctx.editing)
            ? (_openBlock(), _createElementBlock("span", _hoisted_28, _toDisplayString(_ctx.info.rfc), 1))
            : _withDirectives((_openBlock(), _createElementBlock("input", {
                key: 1,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.info.rfc) = $event)),
                type: "text",
                placeholder: "Value",
                class: "bg-background rounded-2xl p-4 focus:outline-none"
              }, null, 512)), [
                [_vModelText, _ctx.info.rfc]
              ])
        ]),
        _hoisted_29,
        _createElementVNode("div", _hoisted_30, [
          _hoisted_31,
          (!_ctx.editing)
            ? (_openBlock(), _createElementBlock("span", _hoisted_32, _toDisplayString(_ctx.info.entry_day_nom), 1))
            : _withDirectives((_openBlock(), _createElementBlock("input", {
                key: 1,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.info.entry_day_nom) = $event)),
                type: "text",
                placeholder: "Value",
                class: "bg-background rounded-2xl p-4 focus:outline-none"
              }, null, 512)), [
                [_vModelText, _ctx.info.entry_day_nom]
              ])
        ]),
        _hoisted_33
      ])
    ]),
    _createElementVNode("div", _hoisted_34, [
      _hoisted_35,
      _createElementVNode("div", _hoisted_36, [
        _createElementVNode("div", _hoisted_37, [
          _hoisted_38,
          _createElementVNode("span", _hoisted_39, " $" + _toDisplayString(_ctx.info.daily_salary.toLocaleString(undefined, {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              })), 1)
        ]),
        _hoisted_40,
        _createElementVNode("div", _hoisted_43, [
          _hoisted_44,
          (!_ctx.editing)
            ? (_openBlock(), _createElementBlock("span", _hoisted_45, _toDisplayString(_ctx.info.date_entry_imss), 1))
            : _withDirectives((_openBlock(), _createElementBlock("input", {
                key: 1,
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.info.date_of_entry_imss) = $event)),
                type: "text",
                placeholder: "Value",
                class: "bg-background rounded-2xl p-4 focus:outline-none"
              }, null, 512)), [
                [_vModelText, _ctx.info.date_of_entry_imss]
              ])
        ]),
        _hoisted_46,
        _createElementVNode("div", _hoisted_47, [
          _hoisted_48,
          (!_ctx.editing)
            ? (_openBlock(), _createElementBlock("span", _hoisted_49, _toDisplayString(_ctx.info.bank.replaceAll("_", " ")), 1))
            : _withDirectives((_openBlock(), _createElementBlock("select", {
                key: 1,
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.info.bank) = $event)),
                class: "bg-background rounded-2xl p-4 focus:outline-none"
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.bank_options, (bank, i) => {
                  return (_openBlock(), _createElementBlock("option", {
                    key: i,
                    value: bank
                  }, _toDisplayString(bank.replaceAll("_", " ")), 9, _hoisted_50))
                }), 128))
              ], 512)), [
                [_vModelSelect, _ctx.info.bank]
              ])
        ]),
        _hoisted_51,
        _createElementVNode("div", _hoisted_52, [
          _hoisted_53,
          (!_ctx.editing)
            ? (_openBlock(), _createElementBlock("span", _hoisted_54, _toDisplayString(_ctx.info.bank.replaceAll("_", " ")), 1))
            : _withDirectives((_openBlock(), _createElementBlock("input", {
                key: 1,
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.info.bank) = $event)),
                type: "text",
                placeholder: "Value",
                class: "bg-background rounded-2xl p-4 focus:outline-none"
              }, null, 512)), [
                [_vModelText, _ctx.info.bank]
              ])
        ]),
        _hoisted_55,
        _createElementVNode("div", _hoisted_56, [
          _hoisted_57,
          (!_ctx.editing)
            ? (_openBlock(), _createElementBlock("span", _hoisted_58, _toDisplayString(_ctx.info.bank.replaceAll("_", " ")), 1))
            : _withDirectives((_openBlock(), _createElementBlock("input", {
                key: 1,
                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.info.bank) = $event)),
                type: "text",
                placeholder: "Value",
                class: "bg-background rounded-2xl p-4 focus:outline-none"
              }, null, 512)), [
                [_vModelText, _ctx.info.bank]
              ])
        ]),
        _hoisted_59,
        _createElementVNode("div", _hoisted_60, [
          _hoisted_61,
          (!_ctx.editing)
            ? (_openBlock(), _createElementBlock("span", _hoisted_62, _toDisplayString(_ctx.info.account), 1))
            : _withDirectives((_openBlock(), _createElementBlock("input", {
                key: 1,
                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.info.account) = $event)),
                type: "text",
                placeholder: "Value",
                class: "bg-background rounded-2xl p-4 focus:outline-none"
              }, null, 512)), [
                [_vModelText, _ctx.info.account]
              ])
        ]),
        _hoisted_63
      ])
    ])
  ]))
}